export default __webpack_public_path__ + "static/media/share-ig.eca387f9.jpg";